<template>
  <div class="stat-card ownership-card">
    <div class="stat-header">
      <span class="stat-title">BUY BOX OWNERSHIP</span>
      <i class="info circle icon" title="Buy Box ownership percentage across tracked products"></i>
    </div>
    <div class="stat-value">
      <span class="percentage">{{ data.percentage }}</span>
      <span class="percentage-symbol">%</span>
    </div>
    <div class="stat-description">
      You hold the Buy Box on <strong>{{ data.owned }} of {{ data.total }}</strong> tracked products.
    </div>
    <div class="stat-trend" v-if="data.trendText">
      <span class="trend-badge" :class="{ negative: data.trend < 0, positive: data.trend > 0 }">
        <i v-if="data.trend < 0" class="chart line icon"></i>
        <i v-else-if="data.trend > 0" class="chart line icon"></i>
        {{ data.trendText }}
      </span>
    </div>
  </div>
</template>

<script>
import './styles/BuyBoxOwnershipCard.css'

export default {
  name: 'BuyBoxOwnershipCard',
  props: {
    data: {
      type: Object,
      required: true,
      // Expected structure:
      // {
      //   percentage: Number,
      //   owned: Number,
      //   total: Number,
      //   trend: Number,
      //   trendText: String,
      //   source: String,
      //   field: String,
      //   calculation: String,
      //   trendDescription: String
      // }
    }
  }
}
</script>





// WEBPACK FOOTER //
// BuyBoxOwnershipCard.vue?45a3d508